export function formatTime(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours}h ${minutes}m ${seconds}s`;
}

export function calculateSpentTime(timeline = []) {
  let totalMs = 0;
  let isRunning = false;

  timeline.forEach((t) => {
    if (!t.startTime) return;

    const start = new Date(t.startTime).getTime();
    const end = t.endTime ? new Date(t.endTime).getTime() : Date.now();

    if (isNaN(start) || isNaN(end)) return;
    if (end < start) return;

    if (!t.endTime) {
      isRunning = true;
    }

    totalMs += end - start;
  });

  return { totalMs, isRunning };
}

export function getStatusColor(status) {
  const colors = [
    "bg-red-500 text-white",
    "bg-blue-500 text-white",
    "bg-green-500 text-white",
    "bg-yellow-500 text-black",
    "bg-purple-500 text-white",
    "bg-pink-500 text-white",
    "bg-indigo-500 text-white",
    "bg-teal-500 text-white",
    "bg-orange-500 text-white",
    "bg-cyan-500 text-white",
    "bg-lime-500 text-black",
    "bg-emerald-500 text-white",
    "bg-violet-500 text-white",
    "bg-fuchsia-500 text-white",
    "bg-rose-500 text-white",
    "bg-amber-500 text-black",
    "bg-sky-500 text-white",
    "bg-stone-500 text-white",
    "bg-slate-500 text-white",
    "bg-zinc-500 text-white",

    "bg-red-400 text-white",
    "bg-blue-400 text-white",
    "bg-green-400 text-white",
    "bg-yellow-400 text-black",
    "bg-purple-400 text-white",
    "bg-pink-400 text-white",
    "bg-indigo-400 text-white",
    "bg-teal-400 text-white",
    "bg-orange-400 text-white",
    "bg-cyan-400 text-white",
    "bg-lime-400 text-black",
    "bg-emerald-400 text-white",
    "bg-violet-400 text-white",
    "bg-fuchsia-400 text-white",
    "bg-rose-400 text-white",
    "bg-amber-400 text-black",
    "bg-sky-400 text-white",
  ];

  if (!status) return "bg-gray-400 text-white";

  let hash = 0;
  const str = status.toString().toLowerCase();

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  hash = (hash ^ (hash >> 16)) >>> 0;

  const index = hash % colors.length;

  return colors[index];
}

export function getStatusLabelColor(status) {
  switch (status) {
    case "Not started":
      return "text-yellow-600 bg-yellow-100";
    case "In Progress":
      return "text-blue-600 bg-blue-100";
    case "Completed":
      return "text-green-600 bg-green-100";
    case "On Hold":
      return "text-orange-600 bg-orange-100";
    case "Lost":
      return "text-red-600 bg-red-100";
    case "Over Due":
      return "text-red-800 bg-red-200";
    case "In Review":
      return "text-purple-600 bg-purple-100";
    default:
      return "text-gray-600 bg-gray-100";
  }
}

export function escapeRegex(str = "") {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function formatIST(date) {
  if (!date) return "";

  return new Date(date)
    .toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace("am", "AM")
    .replace("pm", "PM");
}

export function getColorFromName(name) {
  let hash = 0;

  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash * 7) % 360;
  const saturation = 65 + (Math.abs(hash) % 15);
  const lightness = 75 + (Math.abs(hash) % 10);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}


export const tailwindBgToHex = {
  "bg-red-500": "#ef4444",
  "bg-blue-500": "#3b82f6",
  "bg-green-500": "#22c55e",
  "bg-yellow-500": "#eab308",
  "bg-purple-500": "#a855f7",
  "bg-pink-500": "#ec4899",
  "bg-indigo-500": "#6366f1",
  "bg-teal-500": "#14b8a6",
  "bg-orange-500": "#f97316",
  "bg-cyan-500": "#06b6d4",
  "bg-lime-500": "#84cc16",
  "bg-emerald-500": "#10b981",
  "bg-violet-500": "#8b5cf6",
  "bg-fuchsia-500": "#d946ef",
  "bg-rose-500": "#f43f5e",
  "bg-amber-500": "#f59e0b",
  "bg-sky-500": "#0ea5e9",
  "bg-stone-500": "#78716c",
  "bg-slate-500": "#64748b",
  "bg-zinc-500": "#71717a",
  "bg-red-400": "#f87171",
  "bg-blue-400": "#60a5fa",
  "bg-green-400": "#4ade80",
  "bg-yellow-400": "#facc15",
  "bg-purple-400": "#c084fc",
  "bg-pink-400": "#f472b6",
  "bg-indigo-400": "#818cf8",
  "bg-teal-400": "#2dd4bf",
  "bg-orange-400": "#fb923c",
  "bg-cyan-400": "#22d3ee",
  "bg-lime-400": "#a3e635",
  "bg-emerald-400": "#34d399",
  "bg-violet-400": "#a78bfa",
  "bg-fuchsia-400": "#e879f9",
  "bg-rose-400": "#fb7185",
  "bg-amber-400": "#fbbf24",
  "bg-sky-400": "#38bdf8",
};